import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import { format, processGeoJSON } from '../modules/helpers';
import * as d3 from 'd3';
import getSchoolUrl from '../modules/get-url';

function makeSchoolsTable(data, school) {
  const elm = document.createElement('div');
  let map;
  const mapContainer = document.createElement('div');
  const allSchoolsMap = document.createElement('div');
  mapContainer.id = 'all-schools-container';
  allSchoolsMap.id = 'all-schools-map';

  function tableRowNavigation(e) {
    const keys = { SPACE: 32, ENTER: 13 };
    const iskeyPress = e.keyCode === keys.SPACE || e.keyCode === keys.ENTER;
    const isClick = e.type === 'click';
    const isFocusedTouch =
      e.type === 'touchend' && this === document.activeElement;
    if (iskeyPress || isClick || isFocusedTouch) {
      e.preventDefault();
      const ref = e.target != null ? e.target : e.srcElement;
      if (!ref) return;
      if (window.parentIFrame) {
        window.parentIFrame.sendMessage({
          type: 'navigate:to',
          url: this.getAttribute('href'),
        });
      } else {
        window.location.search = this.getAttribute('href');
      }
    } else if (e.type === 'touchend') {
      e.preventDefault();
      this.focus();
    }
  }

  var mapOptions = {
    center: new window.google.maps.LatLng(-33.806431, 151.276418),
    zoom: 14,
    zoomControl: false,
    disableDoubleClickZoom: true,
    mapTypeControl: false,
    scaleControl: false,
    scrollwheel: false,
    panControl: true,
    streetViewControl: false,
    draggable: true,
    overviewMapControl: false,
    mapTypeId: 'satellite',
    fullscreenControl: false,
  };

  map = new window.google.maps.Map(allSchoolsMap, mapOptions);

  map.data.addListener('addfeature', function(e) {
    var bounds = new window.google.maps.LatLngBounds();
    processGeoJSON(e.feature.getGeometry(), bounds.extend, bounds);
    map.setCenter(bounds.getCenter());
    map.fitBounds(bounds);
  });

  if (!school) {
    map.data.loadGeoJson(`/data/clusters/${data.uid}.geojson`);
    map.data.setStyle({
      fillColor: 'rgba(225, 255, 255, 0.5)',
      strokeColor: 'rgba(225, 255, 255, 1)',
    });
  } else {
    map.data.loadGeoJson(`/data/schools/${school.uid}.geojson`);
    map.data.setStyle({
      fillColor: 'transpatent',
      strokeColor: '#05E2FC',
    });
  }

  const sorted_schools = data.schools.sort((a, b) => {
    if (a.isActive) {
      return -1;
    }

    if (b.isActive) {
      return 1;
    }

    if (a.enrolment > b.enrolment) {
      return -1;
    }
    if (a.enrolment < b.enrolment) {
      return 1;
    }
    return 0;
  });

  const table = document.createElement('table');
  table.classList.add('all-schools-table');
  table.id = 'summary-table';
  const tbody = document.createElement('tbody');
  const thead = document.createElement('thead');

  table.setAttribute(
    'summary',
    `A table of figures showing enrolment, classrooms and average playspace per child for all schools in the ${data.name} schools group. ${data.name} has ${data.enrolment} students. Clicking table rows, will navigate to the selected schools page.`
  );

  const iconStudent =
    '<svg class="icon-school-table icon-school-table-student" viewBox="4 0 20 38" id="student-icon"><path d="M9.14285714,32 L9.14285714,23.3846154 L7,23.3846154 L7,15.4871795 C7,13.9076923 8.28571429,12.6153846 9.85714286,12.6153846 L14.1428571,12.6153846 C15.7142857,12.6153846 17,13.9076923 17,15.4871795 L17,23.3846154 L14.8571429,23.3846154 L14.8571429,32 L9.14285714,32 Z M12,11.1794872 C13.9821429,11.1794872 15.5714286,9.58205128 15.5714286,7.58974359 C15.5714286,5.5974359 13.9821429,4 12,4 C10.0178571,4 8.42857143,5.5974359 8.42857143,7.58974359 C8.42857143,9.58205128 10.0178571,11.1794872 12,11.1794872 Z"></path></svg>';

  const iconStudentInCircle =
    '<svg class="icon-school-table icon-school-table-student" viewBox="4 0 20 38" id="student-icon"><path d="M9.14285714,32 L9.14285714,23.3846154 L7,23.3846154 L7,15.4871795 C7,13.9076923 8.28571429,12.6153846 9.85714286,12.6153846 L14.1428571,12.6153846 C15.7142857,12.6153846 17,13.9076923 17,15.4871795 L17,23.3846154 L14.8571429,23.3846154 L14.8571429,32 L9.14285714,32 Z M12,11.1794872 C13.9821429,11.1794872 15.5714286,9.58205128 15.5714286,7.58974359 C15.5714286,5.5974359 13.9821429,4 12,4 C10.0178571,4 8.42857143,5.5974359 8.42857143,7.58974359 C8.42857143,9.58205128 10.0178571,11.1794872 12,11.1794872 Z"></path><ellipse cx="12" cy="31.5" rx="7" ry="4" fill="none" stroke-width="2" stroke="inherit"></ellipse></svg>';

  const iconClassroom =
    '<svg class="icon-school-table icon-school-table-classroom" viewBox="0 0 24 24" id="classroom-icon"><polygon points="9,0 0,5 0,17 7,17 7,11 11,11 11,17 18,17 18,5"></polygon></svg>';
  const iconSlice =
    '<svg class="icon-school-table icon-school-table-playspace" viewBox="0 0 40 40"><g transform="translate(20 0)"><g transform="matrix(0.866, 0.5, -0.866, 0.5, 0, 0)"><rect class="rect" width="22.360679774997898" height="22.360679774997898"></rect><rect class="left-side" width="22.360679774997898" height="2" transform="skewX(45) rotate(180 0 0) translate(0 -24.360679774997898)"></rect><rect class="right-side" height="22.360679774997898" width="2" transform="skewY(45) rotate(0 0 22.360679774997898)  translate(22.360679774997898 -22.360679774997898)"></rect></g></g></svg>';

  const headerCols = [
    { icon: iconStudent, text: 'Student<br/>enrolment' },
    { icon: iconStudentInCircle, text: 'Live in<br/>school area' },
    { icon: iconClassroom, text: 'Classrooms total<br/>(demountables)' },
    { icon: iconSlice, text: 'Play space per<br/>student (m&sup2)' },
  ];

  const tableHeadTr = document.createElement('tr');
  const a11yth = document.createElement('th');
  a11yth.innerHTML =
    '<div class="all-schools-table-header a11y">School name</div>';
  tableHeadTr.appendChild(a11yth);
  headerCols.forEach(hcol => {
    const el = document.createElement('th');
    el.innerHTML = `<div class="all-schools-table-header">${hcol.icon}<div>${hcol.text}</div></div>`;
    tableHeadTr.appendChild(el);
  });
  const allyth2 = document.createElement('th');
  allyth2.innerHTML =
    '<div class="all-schools-table-header a11y">Navigate to school</div>';
  tableHeadTr.appendChild(allyth2);
  thead.appendChild(tableHeadTr);

  sorted_schools.forEach((d, i) => {
    const tr = document.createElement('tr');
    const url = getSchoolUrl(d);
    tr.setAttribute('role', 'link');
    tr.setAttribute('href', url);
    tr.setAttribute('tabIndex', '0');
    tr.addEventListener(
      'mouseenter',
      function(e) {
        let lastFocused = this.parentNode.querySelector('.is-focused');
        if (lastFocused) lastFocused.classList.remove('is-focused');
        tr.addEventListener('click', tableRowNavigation, false);
        tr.focus();
      },
      false
    );
    tr.addEventListener(
      'mouseleave',
      function(e) {
        tr.removeEventListener('click', tableRowNavigation, false);
      },
      false
    );
    tr.addEventListener('touchend', tableRowNavigation, false);
    tr.addEventListener('keydown', tableRowNavigation, false);
    if (d.isActive) {
      tr.classList.add('is-selected');
    }

    const gotoTd = document.createElement('td');
    gotoTd.className = 'col-name';
    gotoTd.innerHTML = `<span class="go-to">Go to </span>${d.name}`;
    tr.appendChild(gotoTd);

    const enrolmentTd = document.createElement('td');
    enrolmentTd.className = 'col-enrolment';
    enrolmentTd.innerHTML = `${format(d.enrolment)}`;
    tr.appendChild(enrolmentTd);

    const ligoTd = document.createElement('td');
    ligoTd.className = 'col-ligo';
    ligoTd.innerHTML = isNaN(d.ligo)
      ? '(unknown)'
      : `${format(d.ligo * 100, 0)}%`;
    tr.appendChild(ligoTd);

    const classroomTd = document.createElement('td');
    classroomTd.className = 'col-classrooms';
    classroomTd.innerHTML = `${format(
      d.classrooms.permanent + d.classrooms.demountable
    )}<span>(${format(d.classrooms.demountable)})</span>`;
    tr.appendChild(classroomTd);

    const playspaceTd = document.createElement('td');
    playspaceTd.className = 'col-space';
    playspaceTd.innerHTML = `${format(d.playspace, 2)}`;
    tr.appendChild(playspaceTd);

    const chevron = document.createElement('td');
    chevron.className = 'col-link';
    chevron.innerHTML =
      '<div class="col-link-icon-container"><img src="img/chevron-right.svg" alt="" /></div>';
    tr.appendChild(chevron);

    tbody.appendChild(tr);
  });
  table.appendChild(thead);
  table.appendChild(tbody);

  mapContainer.appendChild(allSchoolsMap);
  elm.appendChild(mapContainer);
  elm.appendChild(table);

  d3
    .select(elm)
    .append('div')
    .style('margin-top', '11px')
    .style('font-size', '11px')
    .text('Data subject to change.*');

  return {
    el: elm,
    map,
  };
}

class AllSchoolsTable extends Component {
  wrapChart() {
    this.container = findDOMNode(this);
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
    const { data, school } = this.props;
    const chart = makeSchoolsTable(data, school);
    this.container.appendChild(chart.el);
  }

  componentDidMount() {
    this.wrapChart();
  }
  componentDidUpdate() {
    this.wrapChart();
  }

  render() {
    return <div />;
  }
}

export default AllSchoolsTable;



// WEBPACK FOOTER //
// ./src/components/all-schools.js